import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import Header from "../components/Header";

import Footer from "../components/Footer";

import PasteListFlowHeader from "../components/PasteListFlowHeader";

import Rectangle1 from "../assets/sainsbury1.jpeg";

import Rectangle2 from "../assets/tesco.jpeg";

import Rectangle3 from "../assets/asda.jpeg";

import Rectangle4 from "../assets/morrisons.jpeg";

import {

  calculateBasketTotals,

  clearPasteListFlow,

  fetchPasteListBasketSummary,

  loadPasteListFlow,

} from "../utils/pasteListFlow";



const retailerBannerByPlatform = {

  sainsbury: Rectangle1,

  tesco: Rectangle2,

  asda: Rectangle3,

  morrison: Rectangle4,

};

const retailerVisitUrls = {

  asda: "https://www.asda.com/",

  tesco: "https://www.tesco.com/",

  morrison: "https://groceries.morrisons.com/",

  sainsbury: "https://www.sainsburys.co.uk/",

};



const emptyBasket = { rows: [], cheapest: null, savings: null, expensiveStore: null };



function PasteListSummary({ onOpenAuth, onOpenMenu }) {

  const navigate = useNavigate();

  const [basket, setBasket] = useState(emptyBasket);

  const [status, setStatus] = useState("loading");



  useEffect(() => {

    let cancelled = false;



    (async () => {

      const flow = loadPasteListFlow();

      const items =

        Array.isArray(flow?.products) && flow.products.length

          ? flow.products

          : Array.isArray(flow?.matches)

          ? flow.matches.map((m) => m.product).filter(Boolean)

          : [];



      if (!items.length && !flow?.lines?.length) {

        navigate("/paste-list", { replace: true });

        return;

      }



      if (flow?.basketTotals?.cheapest) {

        if (!cancelled) {

          setBasket(flow.basketTotals);

          setStatus("succeeded");

        }

        return;

      }



      try {

        const apiBasket = await fetchPasteListBasketSummary(flow?.lines || [], {

          totalCount: flow?.totalCount,

        });

        if (cancelled) return;



        if (apiBasket?.cheapest) {

          setBasket(apiBasket);

        } else {

          setBasket(calculateBasketTotals(items));

        }

        setStatus("succeeded");

      } catch {

        if (cancelled) return;

        setBasket(calculateBasketTotals(items));

        setStatus("succeeded");

      }

    })();



    return () => {

      cancelled = true;

    };

  }, [navigate]);



  return (

    <div className="flex min-h-screen flex-col bg-[#F5F7FB] text-[#24303A]">

      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <PasteListFlowHeader currentStep={3} />



      <main className="mx-auto w-full max-w-6xl flex-1 px-3 py-5 sm:px-4 sm:py-6 md:px-6">

        {status === "loading" && (

          <div className="flex justify-center py-16">

            <span className="text-[16px] text-[#6E7B86]">Calculating basket totals…</span>

          </div>

        )}



        {status === "succeeded" && basket.cheapest ? (

          <>

            <div className="rounded-2xl border border-[#2FC98D80] bg-[#EAFBF3] p-4 shadow-sm sm:p-5">

              <div className="flex items-start gap-2.5 sm:gap-3">

                <span className="shrink-0 text-[24px] sm:text-[28px]" aria-hidden>

                  🏆

                </span>

                <div className="min-w-0">

                  <p className="text-[15px] font-bold leading-snug text-[#24303A] sm:text-[18px]">

                    Cheapest supermarket: {basket.cheapest.label}

                  </p>

                  {basket.savings != null && basket.expensiveStore && (

                    <p className="mt-1 text-[13px] font-medium leading-snug text-[#1FA971] sm:text-[16px]">

                      You&apos;ll save £{basket.savings.toFixed(2)} vs most expensive basket.

                      Compared to {basket.expensiveStore.label}.

                    </p>

                  )}

                </div>

              </div>

            </div>



            <h2 className="mt-6 text-[18px] font-semibold text-[#24303A] sm:text-[20px]">
              Basket total by store
            </h2>

            <div className="mt-4 space-y-3">

              {basket.rows.map((row) => {

                const bannerSrc = retailerBannerByPlatform[row.platform];

                const visitUrl = retailerVisitUrls[row.platform];

                const hasPrice = Number.isFinite(row.total) && row.total > 0;

                return (

                  <div

                    key={row.platform}

                    className={[

                      "relative flex flex-col gap-3 rounded-2xl border px-3 py-3 shadow-sm sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-4",

                      row.isBest

                        ? "border-[#2FC98D80] bg-[#EAFBF3]"

                        : "border-[#E6EAF0] bg-white",

                    ].join(" ")}

                  >

                    {row.isBest && (
                      <span className="absolute left-0 top-0">
                        <span className="relative inline-flex h-7 w-7 items-center justify-center">
                          <span
                            className="absolute inset-0 rounded-br-[10px] rounded-tr-none rounded-l-none bg-[#5B3CC4]"
                            aria-hidden
                          />
                          <svg
                            viewBox="0 0 24 24"
                            className="relative z-10 h-[24px] w-[24px]"
                            fill="none"
                            aria-hidden
                          >
                            <path
                              d="M12 3.2l2.55 5.17 5.7.83-4.12 4.02.97 5.68L12 16.48 6.9 18.92l.97-5.68L3.75 9.2l5.7-.83L12 3.2z"
                              fill="#FFFFFF"
                            />
                          </svg>
                        </span>
                      </span>
                    )}

                    <div className="flex min-w-0 items-center gap-3">

                      <div className="flex h-10 w-24 shrink-0 items-center justify-center overflow-hidden rounded-md border border-[#E6EAF0] bg-white sm:h-11 sm:w-28">

                        {bannerSrc ? (

                          <img
                            src={bannerSrc}
                            alt={row.label}
                            className="h-full w-full object-cover mt-2"
                            loading="lazy"
                          />
                        ) : (

                          <span className="text-[11px] font-semibold text-[#24303A] sm:text-[12px]">{row.label}</span>

                        )}

                      </div>

                      <span className="text-[16px] font-bold text-[#24303A] sm:text-[18px]">

                        {hasPrice ? `£${row.total.toFixed(2)}` : "—"}

                      </span>

                    </div>

                    <div className="flex w-full items-center justify-between gap-2 sm:w-auto sm:shrink-0 sm:justify-end sm:gap-3">

                      {row.isBest ? (

                        <span className="rounded-full bg-[#1FA971] px-2.5 py-1 text-[12px] font-semibold uppercase tracking-wide text-white sm:px-3 sm:text-[14px]">

                          Best Price

                        </span>

                      ) : (

                        <span className="rounded-full bg-white px-2.5 py-1 text-[12px] font-semibold text-[#6E7B86] ring-1 ring-[#E6EAF0] sm:px-3 sm:text-[14px]">

                          +£{row.delta.toFixed(2)}

                        </span>

                      )}

                      <button

                        type="button"

                        className={[

                          "rounded-full px-3 py-1.5 text-[13px] font-semibold disabled:cursor-not-allowed sm:py-1 sm:text-[16px]",

                          visitUrl && hasPrice

                            ? "bg-[#7352C71A] text-[#7352C7]"

                            : "bg-[#7352C71A] text-slate-400",

                        ].join(" ")}

                        disabled={!visitUrl || !hasPrice}

                        onClick={() => {

                          if (!visitUrl || !hasPrice) return;

                          window.open(visitUrl, "_blank", "noopener,noreferrer");

                        }}

                      >

                        Visit Store

                      </button>

                    </div>

                  </div>

                );

              })}

            </div>

          </>

        ) : null}



        {status === "succeeded" && !basket.cheapest ? (

          <div className="rounded-2xl border border-[#E6EAF0] bg-white px-4 py-8 text-center shadow-sm">

            <p className="text-[16px] font-semibold text-[#24303A]">No basket totals available yet</p>

            <p className="mt-2 text-[14px] text-[#6E7B86]">

              We could not calculate store totals from the matched items. Try editing your list and matching again.

            </p>

            <button

              type="button"

              onClick={() => {
                clearPasteListFlow();
                navigate("/paste-list");
              }}

              className="mt-5 w-full rounded-full bg-[#0d9499] px-6 py-2.5 text-[14px] font-semibold text-white sm:w-auto sm:py-2 sm:text-[16px]"

            >

              Start again

            </button>

          </div>

        ) : null}



        {status === "succeeded" && basket.cheapest ? (

          <div className="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">

            <button

              type="button"

              onClick={() => navigate("/paste-list/review")}

              className="w-full rounded-full border border-[#E6EAF0] bg-white px-5 py-2.5 text-[14px] font-semibold text-[#24303A] sm:w-auto sm:py-2 sm:text-[16px]"

            >

              Back to review

            </button>

            <button

              type="button"

              onClick={() => {
                clearPasteListFlow();
                navigate("/paste-list");
              }}

              className="w-full rounded-full bg-[#7352C7] px-6 py-2.5 text-[14px] font-semibold text-white sm:w-auto sm:py-2 sm:text-[16px]"

            >

              Paste another list

            </button>

          </div>

        ) : null}

      </main>



      <Footer />

    </div>

  );

}



export default PasteListSummary;


